import {ModalBody as NextUIModalBody, ModalBodyProps as NextUIModalProps} from "@heroui/react";
export interface ModalBodyProps extends NextUIModalProps {}
export const ModalBody = ({children, ...props}:ModalBodyProps) => {
  return (
    <NextUIModalBody {...props}>
      {children}
    </NextUIModalBody>
  )
}